import styled from 'styled-components';
import {Form} from 'formik';
import {dFlex, dInlineFlex, alignCenter, justifyCenter, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const form = styled(Form)`
    ${dFlexColumn} ;
    gap: var(--space-xl) ;
    overflow: auto;
    height:calc(100% - 212px);
    padding: var(--space-xl) var(--space-lg);
`;

export const headerEnd = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-md);
`;

export const footer = styled.div`
    ${dFlex}
    ${alignCenter}
    justify-content: flex-end;
    gap: var(--space-lg);
    flex-shrink: 0;
    padding: var(--space-xl);
    border-top: 1px solid var(--color-border-subtle);
    background: var(--color-bg-base);
`;

export const kebab = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: var(--space-xs);
    ${dInlineFlex}
    ${alignCenter}
    ${justifyCenter}
    color: rgba(0, 0, 0, 0.6);
`;
